import { AnalyticsContext } from '@/contexts/AnalyticsContext/AnalyticsContext.js';
import { type AnalyticsContextProps } from '@/contexts/AnalyticsContext/types.js';
import { useContext } from 'react';

export const useAnalytics = (): AnalyticsContextProps => {
  const value = useContext(AnalyticsContext);

  return value;
};
